var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _vm.global.type == "manage"
                  ? _c("div", { staticClass: "tool" }, [
                      _c("h4", [_vm._v("选择客户")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "search" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择客户",
                                loading: _vm.customerLoading,
                                filterable: ""
                              },
                              on: { change: _vm.customerChange },
                              model: {
                                value: _vm.customerValue,
                                callback: function($$v) {
                                  _vm.customerValue = $$v
                                },
                                expression: "customerValue"
                              }
                            },
                            _vm._l(_vm.customerData, function(item) {
                              return _c("el-option", {
                                key: item.client_id,
                                attrs: {
                                  label: item.number + " " + item.client_name,
                                  value: item.client_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "part" },
                  [
                    _c("div", { staticClass: "prompt_header" }, [
                      _c("h5", [_vm._v("提示词")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "prompt_actions" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                plain: "",
                                loading: _vm.enhanceLoading,
                                disabled: !_vm.prompt || !_vm.prompt.trim()
                              },
                              on: { click: _vm.handleAIEnhance }
                            },
                            [
                              _c("i", { staticClass: "el-icon-magic-stick" }),
                              _vm._v(" AI扩写润色\n              ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                size: "small",
                                plain: ""
                              },
                              on: { click: _vm.handlePromptLibrary }
                            },
                            [
                              _c("i", { staticClass: "el-icon-reading" }),
                              _vm._v(" 提示词库\n              ")
                            ]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 6,
                        placeholder:
                          "输入视频描述内容，例如：现代简约客厅，阳光从窗户洒入，镜头缓慢推进",
                        maxlength: "1000",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.prompt,
                        callback: function($$v) {
                          _vm.prompt = $$v
                        },
                        expression: "prompt"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "part" },
                  [
                    _c("h5", [_vm._v("AI大模型")]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {},
                      [
                        _c(
                          "el-radio-group",
                          {
                            on: { input: _vm.aiChange },
                            model: {
                              value: _vm.aiSelected,
                              callback: function($$v) {
                                _vm.aiSelected = $$v
                              },
                              expression: "aiSelected"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "ai_box" },
                              _vm._l(_vm.aiModels, function(item, index) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: "ai" + index,
                                    attrs: { label: item.model_id }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.model_name + "(" + item.price + ")"
                                      )
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("视频时长")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.durationCur,
                          callback: function($$v) {
                            _vm.durationCur = $$v
                          },
                          expression: "durationCur"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "duration_box" },
                          _vm._l(_vm.durationData, function(item, index) {
                            return _c(
                              "el-radio",
                              {
                                key: "duration" + index,
                                attrs: { label: index }
                              },
                              [_vm._v(_vm._s(item + "s"))]
                            )
                          }),
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn_save" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "success",
                          loading: _vm.isGenerating,
                          disabled:
                            !_vm.prompt || !_vm.customerValue || !_vm.aiSelected
                        },
                        on: { click: _vm.handleGenerate }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isGenerating ? "生成中..." : "立即生成"
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        "（本月剩余使用额度 " +
                          _vm._s(_vm.global.money) +
                          "元）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.generatedVideos.length > 0
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("生成结果")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "result_grid video_grid" },
                        _vm._l(_vm.generatedVideos, function(video, index) {
                          return _c(
                            "div",
                            {
                              key: "result" + index,
                              staticClass: "result_item video_item"
                            },
                            [
                              _c("video", {
                                staticClass: "result_video",
                                attrs: { src: video.file_url, controls: "" }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "result_info" }, [
                                _c("p", { staticClass: "result_model" }, [
                                  _vm._v(_vm._s(video.model_name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result_actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDownload(video)
                                          }
                                        }
                                      },
                                      [_vm._v("下载")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isGenerating
                  ? _c("div", { staticClass: "part generating_status" }, [
                      _c(
                        "div",
                        { staticClass: "status_content" },
                        [
                          _c("i", { staticClass: "el-icon-loading" }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("视频生成中，预计需要1-3分钟，请耐心等待...")
                          ]),
                          _vm._v(" "),
                          _c("el-progress", {
                            attrs: {
                              percentage: _vm.generateProgress,
                              format: _vm.formatProgress
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.examples.length > 0
                  ? _c("div", { staticClass: "example_section" }, [
                      _c("div", { staticClass: "example_header" }, [
                        _c("h5", [_vm._v("优质案例")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "example_grid" },
                        _vm._l(_vm.examples, function(item) {
                          return _c(
                            "div",
                            {
                              key: "example" + item.id,
                              staticClass: "example_item",
                              on: {
                                click: function($event) {
                                  return _vm.previewExample(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    item.photo_url +
                                    "?x-oss-process=image/resize,w_300",
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              item.video_url
                                ? _c("div", { staticClass: "video_tag" }, [
                                    _c("i", {
                                      staticClass: "el-icon-video-play"
                                    })
                                  ])
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "提示词库",
                    visible: _vm.libraryVisible,
                    width: "70%",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.libraryVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "library_content" },
                    [
                      _c(
                        "el-menu",
                        {
                          staticClass: "el-menu-demo",
                          attrs: {
                            "default-active": _vm.activeIndex,
                            mode: "horizontal"
                          },
                          on: { select: _vm.handleSelect }
                        },
                        _vm._l(_vm.lexiconLabelData, function(item, index) {
                          return _c(
                            "el-menu-item",
                            {
                              key: "lexiconLabel" + index,
                              attrs: { index: index.toString() }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lexicon_list" },
                        [
                          _vm.lexiconData[_vm.activeIndex] &&
                          _vm.lexiconData[_vm.activeIndex].length > 0
                            ? _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.lexiconCheckList,
                                    callback: function($$v) {
                                      _vm.lexiconCheckList = $$v
                                    },
                                    expression: "lexiconCheckList"
                                  }
                                },
                                _vm._l(
                                  _vm.lexiconData[_vm.activeIndex],
                                  function(item, index) {
                                    return _c("el-checkbox", {
                                      key: "lexicon" + index,
                                      attrs: { label: item.word }
                                    })
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.lexiconData[_vm.activeIndex] ||
                          _vm.lexiconData[_vm.activeIndex].length <= 0
                            ? _c(
                                "div",
                                {},
                                [
                                  _c("el-empty", {
                                    attrs: {
                                      "image-size": 50,
                                      description: "暂无数据"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.lexiconCheckList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "choose_list" },
                            _vm._l(_vm.lexiconCheckList, function(item, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: "choose" + index,
                                  attrs: {
                                    closable: true,
                                    "disable-transitions": true,
                                    type: "success"
                                  },
                                  on: {
                                    close: function($event) {
                                      return _vm.handleClose(index)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.libraryVisible = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.confirmLexicon }
                        },
                        [_vm._v("确定")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "示例详情",
                    visible: _vm.exampleDetailVisible,
                    width: "80%",
                    top: "5vh",
                    "close-on-click-modal": true,
                    "custom-class": "example-detail-dialog"
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.exampleDetailVisible = $event
                    },
                    close: _vm.onExampleDialogClose
                  }
                },
                [
                  _vm.currentExample
                    ? _c("div", { staticClass: "example_detail" }, [
                        _c("div", { staticClass: "detail_left" }, [
                          _vm.currentExample.video_url
                            ? _c("video", {
                                ref: "exampleVideo",
                                staticClass: "detail_video",
                                attrs: {
                                  src: _vm.currentExample.video_url,
                                  poster: _vm.currentExample.photo_url,
                                  controls: ""
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: _vm.currentExample.photo_url,
                                  alt: ""
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "detail_right" }, [
                          _c("div", { staticClass: "detail_item" }, [
                            _c("label", [_vm._v("提示词/描述：")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.currentExample.description))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "detail_item" }, [
                            _c("label", [_vm._v("使用模型：")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.currentExample.model_name))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.currentExample.style_type
                            ? _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("风格类型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.style_type))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentExample.space_type
                            ? _c("div", { staticClass: "detail_item" }, [
                                _c("label", [_vm._v("空间类型：")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.currentExample.space_type))
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "detail_actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "success" },
                                  on: { click: _vm.useThisExample }
                                },
                                [_vm._v("使用此提示词")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81571aa8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81571aa8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TextToVideo/Index.vue
// module id = null
// module chunks = 